import { SiSpringsecurity } from "@onemind-services-llc/react-icons-ng/si";
import { MdIntegrationInstructions } from "@onemind-services-llc/react-icons-ng/md";
import { AiOutlineAntDesign } from "@onemind-services-llc/react-icons-ng/ai";

export const ADVANTAGES_CONSTANTS = [
  {
    icon: SiSpringsecurity,
    title: "Fully Managed & Secure",
    text: "Modular and flexible design for efficient resource management",
  },
  {
    icon: MdIntegrationInstructions,
    title: "Hybrid Integration",
    text: "Modular and flexible design for efficient resource management",
  },
  {
    icon: AiOutlineAntDesign,
    title: "Enterprise Security",
    text: "Modular and flexible design for efficient resource management",
  },
];
